Object.defineProperty(exports, "__esModule", {
    value: true
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _sliced_to_array = require("@swc/helpers/_/_sliced_to_array");
//#region src/node.ts
var sdkImportCache = /* @__PURE__ */ new Map();
function importNodeModule(name) {
    if (!name) throw new Error("import specifier is required");
    if (sdkImportCache.has(name)) return sdkImportCache.get(name);
    var promise = new Function("name", `return import(name)`)(name).then((res)=>res).catch((error)=>{
        console.error(`Error importing module ${name}:`, error);
        sdkImportCache.delete(name);
        throw error;
    });
    sdkImportCache.set(name, promise);
    return promise;
}
var loadNodeFetch = ()=>_async_to_generator._(function*() {
        var fetchModule = yield importNodeModule("node-fetch");
        return fetchModule.default || fetchModule;
    })();
var lazyLoaderHookFetch = (input, init, loaderHook)=>_async_to_generator._(function*() {
        var hook = (url, init)=>{
            return loaderHook.lifecycle.fetch.emit(url, init);
        };
        var res = yield hook(input, init || {});
        if (!res || !(res instanceof Response)) return (typeof fetch === "undefined" ? yield loadNodeFetch() : fetch)(input, init || {});
        return res;
    })();
var createScriptNode = typeof ENV_TARGET === "undefined" || ENV_TARGET !== "web" ? (url, cb, attrs, loaderHook)=>{
    if (loaderHook === null || loaderHook === void 0 ? void 0 : loaderHook.createScriptHook) {
        var hookResult = loaderHook.createScriptHook(url);
        if (hookResult && typeof hookResult === "object" && "url" in hookResult) url = hookResult.url;
    }
    var urlObj;
    try {
        urlObj = new URL(url);
    } catch (e) {
        console.error("Error constructing URL:", e);
        cb(/* @__PURE__ */ new Error(`Invalid URL: ${e}`));
        return;
    }
    var getFetch = ()=>_async_to_generator._(function*() {
            if (loaderHook === null || loaderHook === void 0 ? void 0 : loaderHook.fetch) return (input, init)=>lazyLoaderHookFetch(input, init, loaderHook);
            return typeof fetch === "undefined" ? loadNodeFetch() : fetch;
        })();
    var handleScriptFetch = (f, urlObj)=>_async_to_generator._(function*() {
            try {
                var _vm_constants;
                var res = yield f(urlObj.href);
                var data = yield res.text();
                var _ref = _sliced_to_array._((yield Promise.all([
                    importNodeModule("path"),
                    importNodeModule("vm")
                ])), 2), path = _ref[0], vm = _ref[1];
                var scriptContext = {
                    exports: {},
                    module: {
                        exports: {}
                    }
                };
                var urlDirname = urlObj.pathname.split("/").slice(0, -1).join("/");
                var filename = path.basename(urlObj.pathname);
                var script = new vm.Script(`(function(exports, module, require, __dirname, __filename) {${data}\n})`, {
                    filename,
                    importModuleDynamically: ((_vm_constants = vm.constants) === null || _vm_constants === void 0 ? void 0 : _vm_constants.USE_MAIN_CONTEXT_DEFAULT_LOADER) ?? importNodeModule
                });
                var requireFn;
                requireFn = eval("require");
                script.runInThisContext()(scriptContext.exports, scriptContext.module, requireFn, urlDirname, filename);
                var exportedInterface = scriptContext.module.exports || scriptContext.exports;
                if (attrs && exportedInterface && attrs["globalName"]) {
                    cb(void 0, exportedInterface[attrs["globalName"]] || exportedInterface);
                    return;
                }
                cb(void 0, exportedInterface);
            } catch (e) {
                cb(e instanceof Error ? e : /* @__PURE__ */ new Error(`Script execution error: ${e}`));
            }
        })();
    getFetch().then((f)=>_async_to_generator._(function*() {
            if ((attrs === null || attrs === void 0 ? void 0 : attrs["type"]) === "esm" || (attrs === null || attrs === void 0 ? void 0 : attrs["type"]) === "module") return loadModule(urlObj.href, {
                fetch: f,
                vm: yield importNodeModule("vm")
            }).then((module)=>_async_to_generator._(function*() {
                    yield module.evaluate();
                    cb(void 0, module.namespace);
                })()).catch((e)=>{
                cb(e instanceof Error ? e : /* @__PURE__ */ new Error(`Script execution error: ${e}`));
            });
            handleScriptFetch(f, urlObj);
        })()).catch((err)=>{
        cb(err);
    });
} : (url, cb, attrs, loaderHook)=>{
    cb(/* @__PURE__ */ new Error("createScriptNode is disabled in non-Node.js environment"));
};
var loadScriptNode = typeof ENV_TARGET === "undefined" || ENV_TARGET !== "web" ? (url, info)=>{
    return new Promise((resolve, reject)=>{
        createScriptNode(url, (error, scriptContext)=>{
            if (error) reject(error);
            else {
                var _info_attrs, _info_attrs1;
                var remoteEntryKey = (info === null || info === void 0 ? void 0 : (_info_attrs = info.attrs) === null || _info_attrs === void 0 ? void 0 : _info_attrs["globalName"]) || `__FEDERATION_${info === null || info === void 0 ? void 0 : (_info_attrs1 = info.attrs) === null || _info_attrs1 === void 0 ? void 0 : _info_attrs1["name"]}:custom__`;
                resolve(globalThis[remoteEntryKey] = scriptContext);
            }
        }, info.attrs, info.loaderHook);
    });
} : (url, info)=>{
    throw new Error("loadScriptNode is disabled in non-Node.js environment");
};
var esmModuleCache = /* @__PURE__ */ new Map();
function loadModule(url, options) {
    return _async_to_generator._(function*() {
        if (esmModuleCache.has(url)) return esmModuleCache.get(url);
        var fetch1 = options.fetch, vm = options.vm;
        var code = yield (yield fetch1(url)).text();
        var module = new vm.SourceTextModule(code, {
            importModuleDynamically: (specifier, script)=>_async_to_generator._(function*() {
                    var resolvedUrl = new URL(specifier, url).href;
                    return loadModule(resolvedUrl, options);
                })()
        });
        esmModuleCache.set(url, module);
        yield module.link((specifier)=>_async_to_generator._(function*() {
                var resolvedUrl = new URL(specifier, url).href;
                return yield loadModule(resolvedUrl, options);
            })());
        return module;
    })();
}
//#endregion
exports.createScriptNode = createScriptNode;
exports.loadScriptNode = loadScriptNode; //# sourceMappingURL=node.cjs.map
